import ApiService from '@/services/apiService';
import get from 'lodash/get';

export default {
  data: function () {
    return {
      healthStateMenu: {
        value: false,
        x: 0,
        y: 0,
      },
    };
  },
  computed: {
    healthStatus() {
      return {
        4: this.$i18n_t('NiotaClassic.DeviceMonitoring.invalid'),
        3: this.$i18n_t('NiotaClassic.DeviceMonitoring.unknown'),
        0: this.$i18n_t('NiotaClassic.DeviceMonitoring.ok'),
        1: this.$i18n_t('NiotaClassic.DeviceMonitoring.warning'),
        2: this.$i18n_t('NiotaClassic.DeviceMonitoring.alert'),
      };
    },
    healthStatusItems() {
      return Object.keys(this.healthStatus).map((status) => {
        return { text: this.healthStatus[status], value: [null, 'null'].indexOf(status) < 0 ? status : null };
      });
    },
  },
  methods: {
    ignoreHealthMessage(virtualDevice, msgId) {
      const healthConfig = virtualDevice.healthConfig || [];
      const config = healthConfig.map((c) => {
        if (c.identifier === msgId) {
          return { ...c, isIgnored: !c.isIgnored };
        }
        return c;
      });
      ApiService.virtualDeviceUpdateHealthConfig(this, virtualDevice.id, virtualDevice.healthStateId, config)
        .then(() => {
          this.healthStateMenu.value = false;
          virtualDevice.healthConfig = config;
          return virtualDevice;
          // this.fetchList();
        })
        .catch((error) => {
          const errorTranslateKey = `Error.${get(error, 'response.data.message')}`;
          if (error.response && this.$i18n_t(errorTranslateKey) !== errorTranslateKey) {
            this.$snack(this.$i18n_t(errorTranslateKey), 'error');
          } else {
            this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.snacks.updateFailed'), 'error');
          }
        });
    },
  },
};
